import React, { Component } from 'react';
import { observer } from 'mobx-react';
import UserStore from '../stores/UserStore';
import LoginForm from '../components/LoginForm';
import {withRouter} from 'react-router-dom';



class Navbar extends Component {

  constructor(props) {
    super(props);
    this.doLogout= this.doLogout.bind(this);
  }

  async doLogout(){
    try{
        UserStore.clear();
        window.location.href = '/';
    }catch(e){
      console.log(e)
    }
  }

  render() {
      return (
        	<div class="navbar navbar-expand-md navbar-light bg-body navbar-static">

        		{/* Header with logos */}
        		<div class="navbar-header navbar-light d-none d-md-flex align-items-md-center">
        			<div class="navbar-brand navbar-brand-md">
        				<a href="/" class="d-inline-block">
        					<img src="/global_assets/images/logo_light.png" alt=""></img>
        				</a>
        			</div>

        			<div class="navbar-brand navbar-brand-xs">
        				<a href="/" class="d-inline-block">
        					<img src="/global_assets/images/logo_icon_light.png" alt=""></img>
        				</a>
        			</div>
        		</div>
        		{/* /header with logos */}


        		{/* Mobile controls */}
        		<div class="d-flex flex-1 d-md-none">
        			<div class="navbar-brand mr-auto">
        				<a href="/" class="d-inline-block">
        					<img src="/global_assets/images/logo_light.png" alt=""></img>
        				</a>
        			</div>

        			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
        				<i class="icon-tree5"></i>
        			</button>

        			<button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
        				<i class="icon-paragraph-justify3"></i>
        			</button>

        			<button class="navbar-toggler sidebar-mobile-right-toggle" type="button">
        				<i class="icon-more"></i>
        			</button>
        		</div>
        		{/* /mobile controls */}

        		{/* Navbar content */}
        		<div class="collapse navbar-collapse" id="navbar-mobile">
        			<ul class="navbar-nav">
        				<li class="nav-item">
        					<a href="#" class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block">
        						<i class="icon-paragraph-justify3"></i>
        					</a>
        				</li>

        				<li class="nav-item">
        					<a href="#" class="navbar-nav-link sidebar-control sidebar-right-toggle d-none d-md-block">
        						<i class="icon-indent-decrease2"></i>
        					</a>
        				</li>
        			</ul>

        			<ul class="navbar-nav ml-auto">
                      {UserStore.isLoggedIn &&
        				<li class="nav-item dropdown dropdown-user">
        					<a href="#" class="navbar-nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">
        						<img src={UserStore.picture} class="rounded-circle mr-2" height="34" alt=""></img>
        						<span>{UserStore.username}</span>
        					</a>

        					<div class="dropdown-menu dropdown-menu-right">
        						{/*<a href="#" class="dropdown-item"><i class="icon-cog5"></i> Account settings</a>*/}
        						<a onClick={ () => this.doLogout() } class="dropdown-item"><i class="icon-switch2"></i> Logout</a>
        					</div>
        				</li>
              }
              {!UserStore.isLoggedIn &&
                <li class="nav-item dropdown dropdown-user">
					<a href="#" class="navbar-nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">
                    <span>login</span>
                  </a>

                  <div class="dropdown-menu dropdown-menu-right">
                    <LoginForm/>
                  </div>
                </li>
              }
        			</ul>
        		</div>
        		{/* /navbar content */}

        	</div>
	     )
  }
}

export default observer(Navbar);
